export const ROUTE_PARAM_TYPE = "type";
export const ROUTE_PARAM_AUTOSTART = "autostart";
